import { render, staticRenderFns } from "./ListLabourerPaymentPage.vue?vue&type=template&id=3c94cf0c&scoped=true&"
import script from "./ListLabourerPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ListLabourerPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./ListLabourerPaymentPage.vue?vue&type=style&index=0&id=3c94cf0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94cf0c",
  null
  
)

export default component.exports